import { encodeFunctionData, parseAbi } from 'viem'

// ABI con structs bien formateados
const abi = parseAbi([
  'function changePermissions((address where, (address who, bytes4 what, (uint8 op, uint248 value)[] params)[] grants, (address who, bytes4 what)[] revokes)[] changes)',
])

export const encodeAddPermissions = (task: string, safeclient: string, functions: string): string => {
  if (!task || !safeclient || !functions) {
    throw new Error('undefined params on encodeAddPermissions')
  }

  const args = [
    [
      {
        where: task, // task address
        grants: [
          {
            who: safeclient, // clientSafe
            what: functions, // function selector (bytes4)
            params: [],
          },
        ],
        revokes: [],
      },
    ],
  ]

  return encodeFunctionData({
    abi: abi,
    functionName: 'changePermissions',
    args,
  })
}

export const encodeRemovePermissions = (task: string, safeclient: string, functions: string): string => {
  if (!task || !safeclient || !functions) {
    throw new Error('undefined params on encodeRemovePermissions')
  }

  const args = [
    [
      {
        where: task, // task address
        grants: [],
        revokes: [
          {
            who: safeclient, // clientSafe
            what: functions, // function selector (bytes4)
          },
        ],
      },
    ],
  ]

  return encodeFunctionData({
    abi: abi,
    functionName: 'changePermissions',
    args,
  })
}
